import React, { useState } from 'react';
import classes from '../../assets/Global.module.css';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import Filter from '../../helpers/filter/Filter';
import {
  BsCalendar2Check,
  BsCalendar2Plus,
  BsCalendar2Week,
  BsCalendarEvent,
} from 'react-icons/bs';

const ScheduleHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname.split('/').slice(-1)[0];
  const [filterValue, setFilterValue] = useState<string>('');

  return (
    <>
      <h1>Schedule</h1>
      <Header>
        <div>
          <button
            onClick={() => navigate('view')}
            className={pathName === 'view' ? classes.buttonActive : ''}
          >
            <BsCalendar2Week title="Schedule" />
            <span>Schedule</span>
          </button>
          <button
            onClick={() => navigate('events/create')}
            className={pathName === 'create' ? classes.buttonActive : ''}
          >
            <BsCalendar2Plus title="Create Event" />
            <span>Create Event</span>
          </button>
          <button
            onClick={() => navigate('events/pending')}
            className={pathName === 'pending' ? classes.buttonActive : ''}
          >
            <BsCalendar2Check />
            <span>Pending Events</span>
          </button>
          <button
            onClick={() => navigate('events')}
            className={pathName === 'events' ? classes.buttonActive : ''}
          >
            <BsCalendarEvent title="All Events" />
            <span>All Events</span>
          </button>
        </div>
        {(pathName === 'events' || pathName === 'pending') && (
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder={
              pathName === 'events' ? 'Filter Events' : 'Filter Pending Events'
            }
          />
        )}
      </Header>
      <Outlet context={{ filterValue }} />
    </>
  );
};

export default ScheduleHome;
